<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async(payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

    },
    methods:{
      filter: async function(){
        let responseAlert = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {fileName: "Alert",collectionName: "alerts",filters:{status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
        this.total = responseAlert.count;
        if (responseAlert.status==200){
            this.chart.data.datasets[0].data = [responseAlert.count];
            this.chart.update();
        }
      },
      routerAlert(){
         this.$router.push({ path: '/panic-alert' });
         window.location.href = "?#/panic-alert";
      }
    }
}
</script>
